export default __webpack_public_path__ + "static/media/impacto_m3.26d67ca0.png";